<template>
    <div>
        <b-row>
            <b-col>
                <b-card class="pb-12 barra-nuevos-productos" :style="cssVars">
                    <h4> Resultados de Busqueda</h4>
                </b-card>
            </b-col>
        </b-row>
        <b-row class="tipo-vistas-card justify-content-md-center my-3">        
            <b-col cols="4" md="2">
                <b-button variant="light" @click="typeViewAction(1)" class="mr-2">
                    <b-icon icon="grid3x3-gap" > </b-icon>
                </b-button>
                <b-button variant="light" @click="typeViewAction(2)" class="mr-2">
                    <b-icon icon="grid" > </b-icon>
                </b-button>
                <b-button variant="light" @click="typeViewAction(3)">
                    <b-icon icon="list-ul" > </b-icon>
                </b-button>
            </b-col>  
            <b-col cols="2" md="1">
                <b-form-group>
                    <b-form-select
                    v-model="paginator.pageSize"
                    :options="pageSizeOptions"
                    @change="searchItemsByCategory"
                    >
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col cols="4" md="3">
                <b-form-group>
                    <b-form-select
                    v-model="paginator.order"
                    :options="orderOptions"
                    @change="searchItemsByCategory"
                    >
                    </b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row class="only-mobile-display">
            <b-col >
                <b-form-group>
                    <b-form-select
                    v-model="paginator.pageSize"
                    :options="pageSizeOptions"
                    @change="searchItemsByCategory"
                    >
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group>
                    <b-form-select
                    v-model="paginator.order"
                    :options="orderOptions"
                    @change="searchItemsByCategory"
                    >
                    </b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
        <hr>
        <b-row class="my-3">
            <b-col cols="12" class="justify-content-md-center"> 
                <div >
                    <b-pagination 
                        size="md" 
                        pills 
                        :total-rows="paginator.totalPage" 
                        v-model="paginator.page" 
                        :per-page="1" 
                        @input="changePage" 
                        first-number 
                        last-number>
                    </b-pagination>
                </div>
            </b-col>
        </b-row>
        <div>
            <div v-if="catalogo.length > 0 && displayItem === 1">
                <card-item :items="catalogo" @item-info="itemInfo($event)" @add-item="openAddModal($event)" />
            </div>
            <div v-else-if="catalogo.length > 0 && displayItem === 2">
                <card-item2 :items="catalogo" @item-info="itemInfo($event)" @add-item="openAddModal($event)" />
            </div>
            <div v-else-if="catalogo.length > 0 && displayItem === 3">
                <card-item3 :items="catalogo" @item-info="itemInfo($event)" @add-item="openAddModal($event)" />
            </div>
            <b-alert v-else variant="danger" show>
               Lo sentimos, no se han encontrado resultados para su busqueda.
            </b-alert>
        </div>
        <template v-if="catalogo.length > 0">
            <div class="text-end">
                <b-pagination 
                    size="md" 
                    pills 
                    :total-rows="paginator.totalPage" 
                    v-model="paginator.page" 
                    :per-page="1" 
                    @input="changePage" 
                    first-number 
                    last-number>
                </b-pagination>
            </div>
        </template>
        <addItem @close-modal="closeAddModal" :openModal="itemModal" :item="itemData"/>
    </div>
</template>

<script>
import { mapState, mapMutations} from 'vuex'
import addItem from '@/components/AddItemToCart/AddItem.vue'
import CardItem from '../components/CardItemBase.vue'
import CardItem2 from '../components/CardItem2.vue'
import CardItem3 from '../components/CardItem3.vue'
export default {
    data(){
        return{
            displayItem: 1,
            catalogo: [],
            paginator: {
                page: 1,
                totalPage: 1,
                pageSize: 18,
                order: 0
            },
            itemModal: false,
            itemData: '',
            arrayObject: [],
            pageSizeOptions: [
                { value: 18, text: '18' },
                { value: 24, text: '24' },
                { value: 48, text: '48' }
            ],
            orderOptions: [
                { value: 0, text: 'Orden inicial' },
                { value: 1, text: 'Productos (A-Z)' },
                { value: 2, text: 'Productos (Z-A)' }
            ]
        }
    },
    components: {
        addItem,
        CardItem,
        CardItem2,
        CardItem3
    },
    watch: {
        '$route.params.time' : function () {
        this.searchItemsByCategory();
        this.paginator.page = 1;
        }
    },
    created: function () {
        this.searchItemsByCategory()
    },
    computed: {
        ...mapState('configuration', ['background', 'typeSearch']),
        cssVars() {
            return {
                '--border-bottom': this.background
            };
        },
    },
    methods:{
        ...mapMutations(['setLoading']),
        async searchItemsByCategory(){
            this.setLoading(true)
            this.catalogo = [];
            let search = this.$route.params.texto;
            let pageNumber = this.paginator.page;
            let pageSize =  this.paginator.pageSize;
            let typeSearch = this.typeSearch;
            let orderType = this.paginator.order;
            
            let criterioBusqueda = { search, pageNumber, pageSize, typeSearch, orderType};
            await this.$conectar.post('/busqueda/search-items-empresa-hoyostools', criterioBusqueda)
            .then(response =>{
                this.catalogo = response.data.items;
                this.paginator.totalPage = response.data.totalPages;
                
            })
            .catch(error => {
                console.log(error);
            })
            this.setLoading(false)
        },
        changePage(page){
            this.paginator.page = page;
            this.searchItemsByCategory();
        },
        itemInfo(datos){
            if(datos.empresa_id === 0){
                this.$router.push({ name: 'ItemDetail', params:{ referencia: datos.codigo} });
            }else{
                this.$router.push({ name: 'itemEmpresaDetail', params:{ codigo: datos.codigo} });
            }
        },
        openAddModal(item){
            this.itemModal = true;
            this.itemData = item;
        },
        closeAddModal(){
            this.itemModal = false;
            this.itemData = '';
        },

        typeViewAction(typeView){
            this.displayItem = typeView;
        }
        
    }
}
</script>


<style scoped>

.barra-nuevos-productos{
    background-color: #fffffc;
    background-image: linear-gradient(200deg, #fffffc 0%, #cac7c7 84%);
    border-bottom: 5px solid var(--border-bottom);
}

.only-mobile-display{
    display:none
}

@media screen and (max-width: 800px) {
    .tipo-vistas-card{
        display: none;
    }
    .only-mobile-display{
        display:initial
    }
}




</style>